import { useTheme } from '@mui/material/styles';
import Icon from '@mui/material/Icon';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { useTheme }, "@mui/material/Icon": Icon } } });
export default ClientProvider;
